var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"q10__square mx-1",class:['bg-gradient-to-r', 'from-' + _vm.options.from, 'to-' + _vm.options.to,  _vm.options.from, _vm.options.to]})}
var staticRenderFns = []

export { render, staticRenderFns }